import { ApolloClient, InMemoryCache, from, split } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from '@apollo/client/link/context'
import { getMainDefinition } from '@apollo/client/utilities'
import { WebSocketLink } from '@apollo/client/link/ws'
import { onError } from '@apollo/client/link/error'
import { toast as toastMsg } from 'react-toastify'
import * as Sentry from '@sentry/react'
import { clearUserData, loadStateFn } from '../../utils/localStorage'
import { equal } from '../../utils/javascript'
import { navigationRef } from '../../utils/navigation'

const uploadLink = createUploadLink({ uri: process.env.REACT_APP_BASE_URL })

// eslint-disable-next-line consistent-return
const getToken = async () => {
  const token =
    (await loadStateFn('projectToken')) || loadStateFn('token') || null
  if (token) {
    return token
  }
}

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    authorization:
      loadStateFn('forgetPassToken') ||
      loadStateFn('projectToken') ||
      loadStateFn('token') ||
      null,
    accessToken: loadStateFn('accessToken') || null,
    realmId: loadStateFn('realmId') || null,
    refreshToken: loadStateFn('refreshToken') || null,
  },
}))

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_SOCKET_URL,
  options: {
    reconnect: true,
    connectionParams: async () => {
      const token = await getToken()
      return {
        authorization: token || '',
      }
    },
  },
})

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    try {
      throw new Error(graphQLErrors)
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          customData: {
            name: operation.operationName,
            variables: operation.variables,
          },
        },
        tags: {
          user_action: operation.operationName,
        },
      })
    }
    graphQLErrors.forEach((err) => {
      if (err.extensions.code === 'UNAUTHENTICATED') {
        // console.log(`graphQLErrors123`, graphQLErrors)
        clearUserData()
        window.location.replace(`${window.location.origin}/login`)
      }

      if (err.extensions.code === 'BAD_USER_INPUT') {
        toastMsg.error(err.message, { className: 'alert-danger' })
      }
    })
  }

  if (networkError) {
    try {
      throw new Error(networkError)
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          customData: {
            name: operation.operationName,
            variables: JSON.stringify(operation.variables, null, 0),
          },
        },
        tags: {
          user_action: operation.operationName,
        },
      })
    }
  }

  if (
    networkError?.name === 'TypeError' &&
    networkError?.message === 'Failed to fetch'
  ) {
    clearUserData()
    navigationRef.navigate.replace('/login')
    // console.log(' networkError?.name', networkError?.name)
  }
  // if (networkError) {
  //   console.log(`[Network error]: ${networkError}`)
  //   console.log(`[Network error]: ${networkError.name}`)
  //   console.log(`[Network error]: ${networkError.stack}`)
  //   console.log(`[Network error]: ${networkError.message}`)
  // }
  return ''
})

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      equal(definition.kind, 'OperationDefinition') &&
      equal(definition?.operation, 'subscription')
    )
  },
  wsLink,
  authLink.concat(uploadLink),
)

export const apolloClient = new ApolloClient({
  link: from([errorLink, splitLink]),
  cache: new InMemoryCache(),
})

export default {
  apolloClient,
}
